"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVehicleReservedQuery = exports.getVehicleStockBySerialNumberQuery = void 0;
const fragments_1 = require("../../types/next/fragments");
exports.getVehicleStockBySerialNumberQuery = `
  query vehicleStock($serialNo: String!) {
    vehicleStock(serialNo: $serialNo) {
      ...vehicleStock
    }
  }
  ${fragments_1.vehicleStockFragment}
`;
exports.isVehicleReservedQuery = `
  query isVehicleReserved($serialNo: String!, $salesPersonId: String) {
    isVehicleReserved(serialNo: $serialNo, salesPersonId: $salesPersonId) {
      isReserved
      message
      serialNo
    }
  }
`;
//# sourceMappingURL=vehicle-stock.js.map